import { useState, useEffect } from 'react';
import { getFaqs } from '@/service';

/**
 * 数据持久化
 * @param key
 * @param initVal
 * @returns
 */
export function useStateWithLocalStorage<T>(key: string, initVal: T): [any, (val: any, needFileNull?: boolean) => void] {
    let preStr;
    try {
        const localStr = localStorage.getItem(key);
        if (localStr) preStr = JSON.parse(localStr);
    } catch (err) {
        console.error('useStateWithLocaleStorage ===>', err);
    }

    const [value, setValue] = useState(preStr || initVal);

    useEffect(() => {
        value && localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    const handleSetValue = (val: any, needFileNull = false) => {
        // 若需要过滤空数据，只保存有数据的情况
        if (needFileNull) {
            const type = typeof val;
            if ((val === null || type === 'string' || type === 'undefined') && !val) return;

            if (Array.isArray(val) === true && val.length === 0) return;

            if (type === 'object' && Object.keys(val).length === 0) return;
        }
        setValue(val);
    };

    return [value, handleSetValue];
}

/**
 * 产品详情页中获取support的所有数据
 * @param getProductMsg
 * @param locale
 * @param productMsg
 * @returns
 */
export function useSupportData(getProductMsg: any, locale: string | undefined, productMsg: any, spuId?: string): any {
    const [resProductCatagory, setResProductCatagory] = useState([]);
    const [productDetail, setProductDetail] = useState({});
    const [supportData, setSupprtData] = useState({
        faqList: [],
        downloadList: [],
        videoList: [],
    });

    useEffect(() => {
        getProductMsg(locale, productMsg).then((res: any) => {
            const { resProductCatagory, productDetail, supportData } = res || {};
            setResProductCatagory(resProductCatagory);
            setProductDetail(productDetail);
            if (!spuId) {
                setSupprtData(supportData);
            } else {
                (async () => {
                    // DPU + SHP2 faq 黄龙说临时使用这个接口
                    try {
                        const res = await getFaqs({ spuIds: spuId, size: 100 });
                        if (res?.code === '0') {
                            setSupprtData({ ...supportData, faqList: res?.data?.content || [] });
                        } else {
                            console.error(res?.message);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                })();
            }
        });
    }, []);

    return [resProductCatagory, productDetail, supportData];
}
